import { CartItemQuantity } from '../types/models';
import { ShopifyCart } from '../types/servicesShopifyCart';
import { useShopifyCartService } from '../services/shopifyCart';
import { getCartRuleChanges } from '../cartRules/cartRuleChanges';
import {
  getProductBySku,
  getVariantIdBySku,
} from '@/features/Product/composables/productLookupHelper';
import { useProductStockStore } from '@/features/Product/stores/productStock';

let isValidatingCart = false;

export const useCartValidation = () => {
  const { updateCart, addToCart, getCart } = useShopifyCartService();
  const { checkAddStockWithRedraws } = useProductStockStore();

  const toUpdateObject = (items: CartItemQuantity[]) =>
    Object.fromEntries(items.map(({ key, quantity }) => [key, quantity]));

  const validateCart = async (cart: ShopifyCart): Promise<ShopifyCart> => {
    if (isValidatingCart) return cart;
    isValidatingCart = true;
    try {
      const {
        add: itemsToAdd,
        update: itemsToUpdate,
        remove: itemsToRemove,
        redrawAdd,
      } = getCartRuleChanges(cart);

      if (!itemsToAdd.length && !itemsToUpdate.length && !itemsToRemove.length) {
        return cart;
      }

      try {
        if (itemsToRemove.length) {
          await updateCart(toUpdateObject(itemsToRemove));
        }

        if (itemsToUpdate.length) {
          await updateCart(toUpdateObject(itemsToUpdate));
        }

        if (itemsToAdd.length) {
          const { stockCheck, items } = await checkAddStockWithRedraws(itemsToAdd, redrawAdd);
          if (stockCheck === 'available') await addToCart(items);
        }
      } catch (error) {
        console.error('Failed to apply cart rules', error);
      }

      return getCart();
    } finally {
      isValidatingCart = false;
    }
  };

  return {
    validateCart,
    getVariantIdBySku,
    getProductBySku,
  };
};
